import isEmptyObject from '../../src-i-adapter/helpers/is-empty-object';

/**
 * Check if the multiple vinit calls are invoked for same merchant
 * To validate the identity of Merchant, we compare: apikey, externalProfileId and externalClientId
 * @param {Object} configs : merchant SDK latest configs
 * @param {Object} OrchCustomData : OrchCustomData state
 * @return {Boolean}
 */
const isVInitReinvokedForSameMerchant = (configs, OrchCustomData) => {
  const configsVInitRequest = configs && configs.vInitRequest;
  const orchVInitRequest = OrchCustomData && OrchCustomData.currVInitConfigs;

  if (isEmptyObject(configsVInitRequest) || isEmptyObject(orchVInitRequest)) {
    return false;
  }

  const isApikeySame = configsVInitRequest.apikey === orchVInitRequest.apikey;
  const isExternalProfileIdSame =
    configsVInitRequest.externalProfileId === orchVInitRequest.externalProfileId;
  const isExternalClientIdSame =
    configsVInitRequest.externalClientId === orchVInitRequest.externalClientId;

  return isApikeySame && isExternalProfileIdSame && isExternalClientIdSame;
};

export default isVInitReinvokedForSameMerchant;
